import { ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import SearchBox from '../../../../../components/Form/SearchBox/SearchBox';
import { LABEL_POSITIONS } from '../../../../../components/Form/_constants';
import { getOrganizationID, getOrganizations } from './_api';
import { FORM_KEYS } from './_constants';
/**
 * Searchable text field for organization information
 * @param {*} props needed by organizationSearchBox component
 * @returns {ReactElement} Contextualized SearchBox Field Component
 */
const OrganizationSearchBox = ({
	helperText,
	labelPosition,
	onChange,
	touched,
}) => {
	const [organizationOptions, setOrganizationOptions] = useState([]);
	const [sCustomError, setCustomError] = useState('');

	return (
		<SearchBox
			helperText={helperText}
			inputProps={{ customError: sCustomError, required: true }}
			label='Organization'
			labelPosition={labelPosition ? labelPosition : LABEL_POSITIONS.TOP}
			name={FORM_KEYS.ORGANIZATION_NAME}
			type='text'
			options={organizationOptions}
			onSearch={value =>
				getOrganizations(value).then(payload =>
					setOrganizationOptions(payload)
				)
			}
			onChange={async e => {
				onChange(e);
				let organizationID = '';
				if (e.target && e.target.value) {
					const payload = await getOrganizationID(e.target.value);
					if (payload && payload.length === 1) {
						organizationID = payload[0];
					}
				}
				onChange({
					target: {
						name: 'ORGANIZATION_ID',
						value: organizationID,
					},
				});
			}}
			validate={value => {
				let errorMessage;
				if (touched) {
					if (!organizationOptions.includes(value)) {
						errorMessage = 'Please select a valid organization.';
					}
					setCustomError(errorMessage ? errorMessage : '');
				}
				return errorMessage;
			}}
		/>
	);
};

OrganizationSearchBox.propTypes = {
	onChange: PropTypes.func.isRequired,
};

export { OrganizationSearchBox };
